export default function ResidentialRemodelingServices() {
  const services = [
    {
      icon: 'ri-home-smile-line',
      title: 'Kitchen Remodeling Excellence',
      description: `Kitchen remodeling is the most popular home improvement in El Paso, offering the highest return on investment. Modern kitchens feature open layouts, energy-efficient appliances, and durable materials suited to our climate. Quality contractors understand proper ventilation for desert heat, water-efficient fixtures, and cabinetry that withstands temperature fluctuations. Expect 4-8 weeks for complete kitchen renovations with costs ranging $25,000-$75,000 depending on size and finishes.`
    },
    {
      icon: 'ri-drop-line',
      title: 'Bathroom Renovation Specialists',
      description: `Bathroom remodeling transforms outdated spaces into luxurious retreats while improving functionality. El Paso contractors specialize in water-efficient fixtures, proper ventilation to prevent moisture issues, and tile work that handles our climate. Popular upgrades include walk-in showers, double vanities, and heated floors. Master bath renovations typically cost $15,000-$40,000, while guest baths range $8,000-$20,000. Projects usually complete in 2-4 weeks.`
    },
    {
      icon: 'ri-building-line',
      title: 'Room Additions and Extensions',
      description: `Adding square footage increases home value and functionality without relocating. Popular additions in El Paso include master suites, sunrooms, and home offices. Contractors must match existing architecture, ensure proper foundation for our soil conditions, and integrate HVAC systems efficiently. Room additions cost $100-$300 per square foot depending on complexity. Permits and structural engineering are required for all additions.`
    },
    {
      icon: 'ri-sun-line',
      title: 'Outdoor Living Space Creation',
      description: `El Paso's climate is perfect for outdoor living spaces that extend your home's usable area. Expert contractors design covered patios, outdoor kitchens, pergolas, and entertainment areas that provide shade and comfort. Materials must withstand intense UV exposure and temperature extremes. Quality installations include proper drainage, electrical for lighting and appliances, and durable finishes. Outdoor projects range $10,000-$50,000+.`
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Whole Home Renovations',
      description: `Complete home remodeling transforms every aspect of your residence, from layout to finishes. El Paso contractors coordinate multiple trades, manage complex timelines, and ensure cohesive design throughout. Projects often include structural modifications, updated electrical and plumbing, new flooring, and modern fixtures. Whole home renovations typically cost $100,000-$300,000+ and take 3-6 months. Detailed planning prevents costly changes mid-project.`
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Energy Efficiency Upgrades',
      description: `Energy-efficient remodeling is essential in El Paso where cooling costs dominate utility bills. Smart upgrades include enhanced insulation, energy-efficient windows, LED lighting, and modern HVAC systems. Contractors experienced with desert conditions understand thermal barriers, proper sealing, and ventilation strategies. Energy upgrades often qualify for rebates from El Paso Electric. Investments typically pay back within 5-10 years through reduced utility costs.`
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Remodeling Services Specific to El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            El Paso's unique desert climate and architectural styles require specialized remodeling expertise. Our featured contractors understand local building codes, climate challenges, and design trends that work best for our region.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                <i className={`${service.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm text-gray-700 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
